import React from 'react';
import { ArrowRight, MessageCircle, Globe, Clock, Shield, User } from 'lucide-react';
export function PersonalTrustSection() {
  const scrollToForm = () => {
    document.getElementById('plan-trip')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white border-y border-gray-200" data-id="element-111">
      <div className="max-w-7xl mx-auto" data-id="element-112">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-113">
          {/* Image */}
          <div className="aspect-[3/4] w-full rounded-lg overflow-hidden shadow-sm" data-id="element-114">
            <img src="https://images.unsplash.com/photo-1539635278303-d4002c07eae3?w=800&q=80&auto=format&fit=crop" alt="Netanel traveling the world" className="w-full h-full object-cover" data-id="element-115" />
          </div>

          {/* Content */}
          <div className="flex flex-col justify-center" data-id="element-116">
            <h2 className="md:text-4xl font-bold text-[#1f2933] mb-8 text-[28px]" data-id="element-117">
              Travel with Someone Who Has Lived It
            </h2>

            <div className="space-y-4 text-[#4b5563] text-base md:text-lg leading-relaxed mb-8" data-id="element-118">
              <p data-id="element-119">
                I'm Netanel, a long-term traveler with over 17 years of
                real-world travel experience across Asia, Europe, and beyond.
              </p>
              <p data-id="element-120">
                I've spent more than half my life on the road, exploring
                countries, cultures, and destinations from every angle — not
                just as a tourist, but as someone living the journey.
              </p>
              <p data-id="element-121">
                Along the way, I've faced and learned how to avoid the real
                problems travelers don't expect — from bad hotel choices and
                unreliable flights to hidden risks and situations that can
                quickly turn a dream vacation into a stressful experience.
              </p>
              <p data-id="element-122">
                This experience allows me to help you avoid mistakes, choose the
                right places, and build a smooth, safe, and unforgettable travel
                experience.
              </p>
              <p className="font-medium text-[#1f2933]" data-id="element-123">
                My goal is simple: help you travel smarter, safer, and better —
                with the confidence of someone who has already been there.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-124">
              <button onClick={scrollToForm} className="bg-[#1f2933] text-white px-8 py-4 rounded font-semibold hover:bg-[#374151] transition-colors flex items-center justify-center" data-id="element-125">
                Plan Your Trip with Me <ArrowRight className="ml-2 h-5 w-5" data-id="element-126" />
              </button>
              <a href="https://api.whatsapp.com/send?phone=972529566211" target="_blank" rel="noopener noreferrer" className="border border-gray-300 text-[#1f2933] px-8 py-4 rounded font-semibold hover:bg-gray-50 transition-colors flex items-center justify-center" data-id="element-127">
                <MessageCircle className="mr-2 h-5 w-5" data-id="element-128" />
                Chat on WhatsApp
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-2 gap-4 pt-8 border-t border-gray-200" data-id="element-129">
              <div className="flex items-center gap-3" data-id="element-130">
                <div className="w-10 h-10 rounded-full bg-[#f5f5f7] flex items-center justify-center flex-shrink-0" data-id="element-131">
                  <Clock className="h-5 w-5 text-[#4b5563]" data-id="element-132" />
                </div>
                <span className="text-sm font-medium text-[#1f2933]" data-id="element-133">
                  17+ Years Travel Experience
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-134">
                <div className="w-10 h-10 rounded-full bg-[#f5f5f7] flex items-center justify-center flex-shrink-0" data-id="element-135">
                  <Globe className="h-5 w-5 text-[#4b5563]" data-id="element-136" />
                </div>
                <span className="text-sm font-medium text-[#1f2933]" data-id="element-137">
                  Worldwide Destination Expertise
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-138">
                <div className="w-10 h-10 rounded-full bg-[#f5f5f7] flex items-center justify-center flex-shrink-0" data-id="element-139">
                  <Shield className="h-5 w-5 text-[#4b5563]" data-id="element-140" />
                </div>
                <span className="text-sm font-medium text-[#1f2933]" data-id="element-141">
                  Personal VIP Concierge Support
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-142">
                <div className="w-10 h-10 rounded-full bg-[#f5f5f7] flex items-center justify-center flex-shrink-0" data-id="element-143">
                  <User className="h-5 w-5 text-[#4b5563]" data-id="element-144" />
                </div>
                <span className="text-sm font-medium text-[#1f2933]" data-id="element-145">
                  Real Traveler, Real Experience
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}